<template>
  <div class="zwx-select-area">
    <el-popover ref="area" popper-class="zwx-select-area-popper" v-model="visible" trigger="manual" placement="bottom-start" @show="popperShow()" :disabled="disabled" :popper-options="boundaries">
      <div v-clickoutside="clickPopoverOut">
        <!-- 搜索 -->
        <div style="padding: 2px 6px 2px 6px;" v-if="!ifLoading || searchVisible">
          <el-input class="zwx-input" :ref="searchRef" :style="'width: ' + (poperWidth - 12) + 'px !important;'" slot="reference" v-model="searchZoneNameLike" placeholder="检索" :disabled="disabled" @keyup.enter.native="searchAreaList">
            <i class="el-icon-search zwx-el-icon-search" slot="suffix" @click.stop="searchAreaList" />
          </el-input>
        </div>
        <div :class="poperClass" style="display: flex;">
          <!-- 搜索展示 -->
          <div class="zwx-select-area-popper-list" v-if="searchVisible">
            <zwx-scrollbar-y style="height: 100%;" ref="searchScrollbar">
              <div class="zwx-select-area-popper-item" v-for="(item, index) in searchAreaShowList" :key="index" @click="itemSearchClick(item)">{{ item.fullName }}</div>
              <!-- 空提示 -->
              <div class="zwx-select-area-popper-item-none" v-if="!searchLoading && searchAreaShowList.length === 0">无数据</div>
            </zwx-scrollbar-y>
          </div>
          <!-- 级联展示 -->
          <div class="zwx-select-area-popper-list" v-else v-for="(itemList, listIndex) in areaShowList" :key="listIndex">
            <zwx-scrollbar-y style="height: 100%;" ref="scrollbar">
              <div :class="tool.checkMouseoverRoute($system, mouseoverArea, item) ? 'zwx-select-area-popper-item hover' : 'zwx-select-area-popper-item'" v-for="(item, index) in itemList" :key="index" @mouseover="itemMouseover(item, listIndex)" @click="itemClick(item, listIndex)">
                <span :class="tool.checkChooseRoute($system, chooseArea, item) ? 'zwx-select-area-popper-content choose' : 'zwx-select-area-popper-content'">{{ item.zoneName }}</span>
                <span :class="tool.checkChooseRoute($system, chooseArea, item) ? 'zwx-select-area-popper-icon choose' : 'zwx-select-area-popper-icon'" v-if="!item.ifLeaf">
                  <i :class="item.loading === 1 ? 'el-icon-loading' : 'el-icon-arrow-right'" />
                </span>
              </div>
            </zwx-scrollbar-y>
          </div>
        </div>
      </div>
      <!-- 显示内容 -->
      <el-input class="zwx-input" slot="reference" v-model="inputValue" :placeholder="placeholder" readonly auto-complete="off" :disabled="disabled" v-clickoutside="clickInputOut" @click.native="clickInput">
        <i :class="inputClass" slot="suffix" @click.stop="iClick()" />
      </el-input>
    </el-popover>
  </div>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import Tool from './js/tool'
export default {
  name: 'ZwxSelectArea',
  directives: { Clickoutside },
  components: {},
  props: {
    placeholder: { type: String, required: false, default: '' },
    clearable: { type: Boolean, required: false, default: true },
    disabled: { type: Boolean, required: false, default: false },
    zoneCode12From: { type: String },
    zoneTypeMax: { type: String },
    zoneTypeMin: { type: String },
    showFullName: { type: Boolean, default: true },
    serviceName: { type: String, default: 'systematic' },
    apiSign: { type: Boolean, default: true },
  },
  data() {
    return {
      api: this.$store.state.api,
      tool: Tool,
      inputValue: '',
      ifInitSearch: true,
      visible: false,
      ifClickPopoverOut: false,
      ifClickInputOut: false,
      ifLoading: false,
      zoneTypeAreaMax: 0,
      areaList: [],
      areaShowList: [],
      xAreaShowList: [],
      chooseAreaShowList: [],
      zoneCode12Choose: undefined,
      chooseArea: undefined,
      mouseoverArea: undefined,
      searchVisible: false,
      searchLoading: false,
      searchZoneNameLike: '',
      searchAreaShowList: [],
      poperClass: 'zwx-select-area-' + this.$system.uuid(),
      poperWidth: 12,
      searchRef: 'searchInput_' + this.$system.uuid(),
      boundaries: null,
    }
  },
  created() {},
  mounted() {
    this.$zwxBases.listenDocumentWH(document.getElementsByClassName(this.poperClass)[0], this.poperCallback)
    this.boundaries = { boundariesElement: document.querySelector('#app') }
  },
  watch: {
    chooseArea: {
      handler: function(newValue) {
        if (newValue === undefined) this.inputValue = ''
        else if (this.showFullName) this.inputValue = newValue.fullName.replace(/-/g, ' / ').replace(/_/g, ' / ')
        else this.inputValue = newValue.zoneName
        this.$emit('change')
      },
      deep: true,
    },
    areaShowList: {
      handler: function() {
        this.poperWidth = 12
        this.$nextTick(() => {
          this.poperWidth = document.getElementsByClassName(this.poperClass) && document.getElementsByClassName(this.poperClass).length && document.getElementsByClassName(this.poperClass)[0].offsetWidth
        })
      },
      deep: true,
    },
    searchVisible: function() {
      this.poperWidth = 12
      this.$nextTick(() => {
        this.poperWidth = document.getElementsByClassName(this.poperClass) && document.getElementsByClassName(this.poperClass).length && document.getElementsByClassName(this.poperClass)[0].offsetWidth
      })
    },
  },
  computed: {
    inputClass() {
      if (this.ifLoading || this.searchLoading) return 'el-icon-loading'
      return (this.visible ? 'zwx-select-area-input__caret el-icon-arrow-up el-input__icon is-reverse' : 'zwx-select-area-input__caret el-icon-arrow-up el-input__icon') + (!this.disabled && this.clearable && this.inputValue.length > 0 ? ' is-clearable' : '')
    },
    searchInputStyle() {
      return this.searchVisible || JSON.parse(JSON.stringify(this.areaShowList)).length > 1 ? 'width: 100% !important;' : 'width: 100% !important;'
    },
  },
  methods: {
    // 点击popover之外
    clickPopoverOut() {
      this.ifClickPopoverOut = true
      this.clickOut()
    },
    // 点击input之外
    clickInputOut() {
      this.ifClickInputOut = true
      this.clickOut()
    },
    // 只有同时点击popover和input之外，才会主动隐藏
    clickOut() {
      if (this.ifClickPopoverOut && this.ifClickInputOut) {
        this.visible = false
        this.ifClickPopoverOut = false
        this.ifClickInputOut = false
      }
    },
    // 点击input
    clickInput() {
      if (this.disabled) return
      this.visible = !this.visible
      this.ifClickPopoverOut = false
      this.ifClickInputOut = false
    },
    poperCallback(offsetWidth) {
      this.poperWidth = offsetWidth
    },
    initSearch(zoneCode12Choose) {
      this.ifLoading = true
      let data = {
        zoneCode12From: this.zoneCode12From,
        zoneTypeMax: this.zoneTypeMax,
        zoneTypeMin: this.zoneTypeMin,
        zoneCode12Choose: zoneCode12Choose,
      }
      this.zoneCode12Choose = zoneCode12Choose
      this.$system.get(this.api + '/' + this.serviceName + '/getCascaderArea-0', data, false, this.apiSign, this.initSearchSuccess, this.initSearchError)
    },
    initSearchSuccess(data) {
      if (data.type === '00') {
        const initAreaResult = this.tool.initAreaResult(this.areaList, data.areaList, this.zoneTypeAreaMax)
        this.zoneTypeAreaMax = initAreaResult.zoneTypeAreaMax
        const duplicateRemovalAreaList = initAreaResult.duplicateRemovalAreaList
        this.chooseArea = this.tool.checkChoose(data.areaList, this.zoneCode12Choose, this.clearable)
        this.tool.initAllList(duplicateRemovalAreaList, this.areaShowList, this.xAreaShowList, this.chooseAreaShowList, this.zoneTypeAreaMax)
        this.scroolbarScroll()
        if (this.ifInitSearch) this.$emit('success')
      } else {
        if (this.ifInitSearch) this.$emit('error', data)
      }
      if (this.ifInitSearch) this.$emit('loadOver')
      this.ifInitSearch = false
      this.ifLoading = false
    },
    initSearchError() {
      if (this.ifInitSearch) this.$emit('loadOver')
      this.ifInitSearch = false
      this.ifLoading = false
    },
    searchAreaList() {
      if (this.searchZoneNameLike.trim() === '') {
        this.searchVisible = false
        this.searchZoneNameLike = ''
        this.searchAreaShowList.splice(0, this.searchAreaShowList.length)
        return
      }
      if (this.searchLoading) return
      this.searchLoading = true
      this.searchVisible = true
      let data = {
        zoneCode12From: this.zoneCode12From,
        zoneTypeMax: this.zoneTypeMax,
        zoneTypeMin: this.zoneTypeMin,
        zoneNameLike: this.searchZoneNameLike,
      }
      this.$system.get(this.api + '/' + this.serviceName + '/getSearchAreaListByZoneName-0', data, false, this.apiSign, this.searchAreaListSuccess, this.searchAreaListError)
    },
    searchAreaListSuccess(data) {
      if (data.type === '00') {
        this.tool.setSearchAreaShowList(data.areaList, this.searchAreaShowList)
        this.scrollbarSearchScrollIndex()
      }
      this.searchLoading = false
    },
    searchAreaListError() {
      this.searchLoading = false
    },
    scrollbarSearchScrollIndex() {
      this.$nextTick(() => {
        if (!this.$refs.searchScrollbar) return
        this.$refs.searchScrollbar && this.$refs.searchScrollbar.scrollTop(28 - 204)
      })
    },
    itemSearchClick(item) {
      this.visible = false
      this.searchZoneNameLike = ''
      this.chooseArea = item
      this.mouseoverArea = undefined
      this.areaShowList.splice(0, this.areaShowList.length)
      this.initSearch(item.zoneCode12)
    },
    popperShow() {
      this.$nextTick(() => {
        this.$refs[this.searchRef] && this.$refs[this.searchRef].focus()
      })
      this.searchVisible = false
      this.searchZoneNameLike = ''
      this.searchAreaShowList.splice(0, this.searchAreaShowList.length)
      this.mouseoverArea = undefined
      if (this.ifLoading) return
      this.tool.resetAreaShowList(this.chooseArea, this.areaShowList, this.chooseAreaShowList, this.xAreaShowList)
      this.scroolbarScroll()
    },
    scroolbarScroll() {
      let index = 0
      for (let i = 0, length = this.areaShowList.length; i < length; i++) {
        index = 0
        for (let n = 0, nLength = this.areaShowList[i].length; n < nLength; n++) {
          if (this.tool.checkChooseRoute(this.$system, this.chooseArea, this.areaShowList[i][n])) {
            index = n
            break
          }
        }
        this.scrollbarScrollIndex(i, index)
      }
    },
    scrollbarScrollIndex(i, index) {
      this.$nextTick(() => {
        if (!this.$refs.scrollbar || this.$refs.scrollbar.length === 0) return
        if (i >= this.$refs.scrollbar.length) return
        this.$refs.scrollbar[i].scrollTop((index + 1) * 28 - 204)
      })
    },
    itemMouseover(item, listIndex) {
      if (this.$system.isMobile()) return
      if (this.mouseoverArea !== undefined && this.mouseoverArea.zoneCode12 === item.zoneCode12) return
      this.itemNextShow(item, listIndex)
    },
    itemClick(item, listIndex) {
      if (!this.$system.isMobile() || (this.mouseoverArea !== undefined && this.mouseoverArea.zoneCode12 === item.zoneCode12) || item.ifLeaf) {
        this.itemChoose(item)
      } else {
        this.itemNextShow(item, listIndex)
      }
    },
    itemNextShow(item, listIndex) {
      this.mouseoverArea = item
      if (item.loading === 1) return
      this.areaShowList.splice(listIndex + 1, this.areaShowList.length - 1)
      if (item.ifLeaf) return
      if (item.loading === 2) {
        this.itemClickLoading2(item, listIndex)
      } else {
        this.itemClickLoading0(item, listIndex)
      }
    },
    itemClickLoading2(item, listIndex) {
      if (this.mouseoverArea === undefined || this.mouseoverArea.zoneCode12 !== item.zoneCode12) return
      this.tool.initAreaShowList(item, this.areaList, this.areaShowList, listIndex)
      this.scrollbarScrollIndex(listIndex + 1, 0)
      this.$forceUpdate()
      this.$nextTick(() => this.$refs['area'] && this.$refs['area'].updatePopper())
    },
    itemClickLoading0(item, listIndex) {
      item.loading = 1
      let data = {
        zoneCode12From: item.zoneCode12,
        zoneTypeMax: item.zoneType + 1,
        zoneTypeMin: this.zoneTypeMin,
      }
      this.$system.get(this.api + '/' + this.serviceName + '/getCascaderArea-0', data, false, this.apiSign, this.itemClickLoading0Success, this.itemClickLoading0Error, { item, listIndex })
    },
    itemClickLoading0Success(data, { item, listIndex }) {
      if (data.type === '00') {
        const initAreaResult = this.tool.initAreaResult(this.areaList, data.areaList, this.zoneTypeAreaMax)
        this.zoneTypeAreaMax = initAreaResult.zoneTypeAreaMax
        item.loading = 2
        this.itemClickLoading2(item, listIndex)
      } else {
        item.loading = 0
      }
    },
    itemClickLoading0Error({ item }) {
      item.loading = 0
    },
    itemChoose(item) {
      if (!item.ifLeaf && item.loading !== 2) return
      this.visible = false
      this.chooseArea = item
      this.mouseoverArea = undefined
      this.tool.setChooseAreaShowList(this.areaShowList, this.chooseAreaShowList)
      this.areaShowList.splice(0, this.areaShowList.length)
    },
    iClick() {
      if (!this.disabled && this.clearable && this.chooseArea) {
        this.chooseArea = undefined
        this.visible = false
      } else {
        this.visible = this.disabled ? false : !this.visible
      }
    },
    clear() {
      if (this.chooseArea !== undefined) this.chooseArea = undefined
    },
    getChooseArea() {
      return this.chooseArea
    },
  },
  beforeDestroy() {
    this.areaList.splice(0, this.areaList.length)
    this.areaShowList.splice(0, this.areaShowList.length)
    this.xAreaShowList.splice(0, this.xAreaShowList.length)
    this.chooseAreaShowList.splice(0, this.chooseAreaShowList.length)
    this.searchAreaShowList.splice(0, this.searchAreaShowList.length)
  },
}
</script>

<style lang="less" scoped>
.zwx-form .el-form-item .zwx-input .el-input__suffix .el-input__suffix-inner .zwx-select-area-input__caret.el-input__icon {
  margin-top: 1px !important;
}

.zwx-input .el-input__suffix .el-input__suffix-inner .zwx-select-area-input__caret.el-input__icon {
  width: 22px !important;
  font-size: 8px !important;
  line-height: 28px !important;
  padding-right: 0 !important;
  color: #6d87a3 !important;
}

.zwx-input .zwx-select-area-input__caret {
  -webkit-transition: -webkit-transform 0.3s !important;
  transition: -webkit-transform 0.3s !important;
  transition: transform 0.3s, -webkit-transform 0.3s !important;
  -webkit-transform: rotateZ(180deg) !important;
  transform: rotateZ(180deg) !important;
  cursor: pointer !important;
}

.zwx-input .zwx-select-area-input__caret.is-reverse:not(.is-clearable) {
  -webkit-transform: rotateZ(0) !important;
  transform: rotateZ(0) !important;
}

.zwx-input.is-disabled .zwx-select-area-input__caret {
  cursor: not-allowed !important;
}

.zwx-input .el-input__inner:hover + .el-input__suffix .zwx-select-area-input__caret.is-clearable::before,
.zwx-input .zwx-select-area-input__caret.is-clearable:hover::before {
  content: '\e78d' !important;
}

.zwx-el-icon-search {
  display: inline-block !important;
  width: 22px !important;
  text-align: center !important;
  height: 100% !important;
  line-height: 28px !important;
  cursor: pointer !important;
}

.zwx-input.is-disabled .zwx-el-icon-search {
  cursor: not-allowed !important;
}

.zwx-input .el-icon-loading {
  color: #316cf5 !important;
  margin-right: 4px !important;
  cursor: pointer !important;
}

.zwx-input.is-disabled .el-icon-loading {
  cursor: not-allowed !important;
}
</style>

<style lang="less">
.zwx-select-area-popper {
  margin: 4px 0 !important;
  border: none !important;
  padding: 0 !important;
  min-width: 160px !important;
  line-height: 3 !important;
}

.zwx-select-area-popper .popper__arrow {
  display: none !important;
}

.zwx-select-area-popper .zwx-select-area-popper-list {
  min-width: 160px !important;
  padding: 0 !important;
  height: 204px !important;
}

.zwx-select-area-popper .zwx-select-area-popper-list + .zwx-select-area-popper-list {
  border-left: 1px solid #a6b9cd !important;
}

.zwx-select-area-popper .zwx-select-area-popper-item {
  position: relative !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  height: 28px !important;
  padding: 0 26px 0 6px !important;
  font-size: 14px !important;
  line-height: 28px !important;
  color: #000000 !important;
  box-sizing: border-box !important;
  cursor: pointer !important;
}

.zwx-select-area-popper .zwx-select-area-popper-item.hover {
  background-color: #e5f5f5 !important;
}

.zwx-select-area-popper .zwx-select-area-popper-item:hover {
  background-color: #e5f5f5 !important;
  color: #316cf5 !important;
}

.zwx-select-area-popper .zwx-select-area-popper-item-none {
  padding: 8px 0 !important;
  color: #444444 !important;
  font-weight: 400 !important;
  -webkit-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
  margin: 0 !important;
  text-align: center !important;
  font-size: 14px !important;
}

.zwx-select-area-popper .zwx-select-area-popper-content {
  margin-left: 2px !important;
}

.zwx-select-area-popper .zwx-select-area-popper-content.choose {
  color: #316cf5 !important;
}

.zwx-select-area-popper .zwx-select-area-popper-icon {
  position: absolute !important;
  color: #000000 !important;
  right: 10px !important;
}

.zwx-select-area-popper .el-icon-arrow-right,
.zwx-select-area-popper .el-icon-loading {
  vertical-align: middle !important;
}

.zwx-select-area-popper .zwx-select-area-popper-item:hover .el-icon-arrow-right,
.zwx-select-area-popper .zwx-select-area-popper-item:hover .el-icon-loading {
  color: #316cf5 !important;
}

.zwx-select-area-popper .zwx-select-area-popper-icon.choose .el-icon-arrow-right,
.zwx-select-area-popper .zwx-select-area-popper-icon.choose .el-icon-loading {
  color: #316cf5 !important;
}

.zwx-select-area-popper .zwx-input .el-input__suffix .el-input__validateIcon {
  display: none !important;
}

.zwx-select-area .zwx-input .el-input__inner {
  padding-right: 22px !important;
  cursor: pointer;
}

.zwx-select-area .zwx-input.is-disabled .el-input__inner {
  cursor: not-allowed !important;
}
</style>
